import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const RenderTooltip = ({ children, title }) => {
  return (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{title}</Tooltip>}>
      <span className="d-inline-block">{children}</span>
    </OverlayTrigger>
  );
};
